import { CreditCard, LockKeyhole, MonitorX, RefreshCcw, ShieldAlert } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function SubscriptionGate({ children, requireSlot = false, routeMode = false }) {
  const { subscription, refresh } = useAuth();

  if (subscription?.isActive && (!requireSlot || subscription.hasScreenSlot)) {
    return children;
  }

  const suspended = subscription?.status === 'suspended';
  const expired = subscription?.status === 'expired';
  const limitReached = requireSlot && subscription?.isActive && !subscription?.hasScreenSlot;
  const title = suspended
    ? 'Account suspended'
    : expired
      ? 'Subscription expired'
      : limitReached
        ? 'Screen limit reached'
        : 'Subscription required';
  const Icon = suspended ? ShieldAlert : limitReached ? MonitorX : LockKeyhole;
  const message = subscription?.message || 'Choose a package to unlock your signage workspace.';

  if (!routeMode) {
    return (
      <div className="gate-card">
        <div className="gate-icon"><Icon size={30} /></div>
        <div><h3>{title}</h3><p>{message}</p></div>
        <Link to="/tenant/subscription" className="btn btn-primary"><CreditCard size={17} /> Manage subscription</Link>
      </div>
    );
  }

  return (
    <div className="subscription-lock-page">
      <div className="subscription-lock-card">
        <div className="subscription-lock-icon"><Icon size={34} /></div>
        <span className="eyebrow">Workspace access</span>
        <h2>{title}</h2>
        <p>{message}</p>
        {subscription?.planName && <div className="lock-plan">Plan <strong>{subscription.planName}</strong></div>}
        <div className="lock-actions">
          {!suspended && <Link to="/tenant/subscription" className="btn btn-primary"><CreditCard size={17} /> {expired ? 'Renew subscription' : 'View packages'}</Link>}
          <button className="btn btn-soft" onClick={refresh}><RefreshCcw size={17} /> Check again</button>
        </div>
        <small>Subscription and Settings remain available so you can renew or contact support. TV screens use the same entitlement and stop playback when access is inactive.</small>
      </div>
    </div>
  );
}
